module.exports = __webpack_public_path__ + "static/img/card_1_11.a7be453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_1_11.png
// module id = teCY
// module chunks = 0